import { Controller } from "@hotwired/stimulus"

// Drag-and-drop reordering. Drag is initiated from a handle
// (data-action="pointerdown->sortable#enable"); on drop the new order is
// persisted via a PATCH request and the page is reloaded so positions stay
// consistent everywhere.
export default class extends Controller {
  static targets = ["item"]
  static values = {
    url: String,
    paramName: { type: String, default: "ids" }
  }

  connect() {
    this.dragging = null
  }

  enable(event) {
    const item = event.target.closest("[data-sortable-target='item']")
    if (item) item.setAttribute("draggable", "true")
  }

  start(event) {
    const item = event.target.closest("[data-sortable-target='item']")
    if (!item || item.getAttribute("draggable") !== "true") {
      event.preventDefault()
      return
    }
    this.dragging = item
    this.startOrder = this.order()
    event.dataTransfer.effectAllowed = "move"
    item.classList.add("sortable-dragging")
  }

  over(event) {
    if (!this.dragging) return
    event.preventDefault()

    const target = event.target.closest("[data-sortable-target='item']")
    if (!target || target === this.dragging || target.parentElement !== this.dragging.parentElement) return

    const rect = target.getBoundingClientRect()
    const after = this.horizontal()
      ? event.clientX > rect.left + rect.width / 2
      : event.clientY > rect.top + rect.height / 2

    if (after) target.after(this.dragging)
    else target.before(this.dragging)
  }

  drop(event) {
    event.preventDefault()
  }

  end() {
    if (!this.dragging) return

    this.dragging.classList.remove("sortable-dragging")
    this.dragging.removeAttribute("draggable")
    const changed = this.startOrder !== this.order()
    this.dragging = null

    if (changed) this.save()
  }

  order() {
    return this.itemTargets.map((item) => item.dataset.sortableId).join(",")
  }

  horizontal() {
    const direction = window.getComputedStyle(this.element).flexDirection
    return direction === "row" || direction === "row-reverse"
  }

  async save() {
    const token = document.querySelector("meta[name='csrf-token']")?.content
    const body = new URLSearchParams()
    this.itemTargets.forEach((item) => body.append(`${this.paramNameValue}[]`, item.dataset.sortableId))

    const response = await fetch(this.urlValue, {
      method: "PATCH",
      headers: { "X-CSRF-Token": token || "", Accept: "application/json" },
      body
    })

    if (response.ok) window.location.reload()
  }
}
